import { PAYMENT_BILL } from "../consts";

export const billPaymentAction = ({ random = 0  }) => ({
    type: PAYMENT_BILL,
    payload : { random  }
});

export default function billPaymentReducer(state = 0, { type, payload }) {

    const actions = {
        [PAYMENT_BILL] : () => ({ payload })
    }

    return actions[type]?.call() || state;
}

